import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ResetTOTP } from '@/modules/profile/types'
import { resetTOTP } from '../../services'
import { ProfileMutationKey } from '@/modules/profile/keys'

export default function useMutationResetTOTP(
	id: string,
	props?: UseBaseMutationOptions<void, ResetTOTP>,
) {
	return useMutation({
		mutationKey: [ProfileMutationKey.ResetTOTP, id],
		mutationFn: (params) => resetTOTP(id, params),
		...props,
	})
}
